var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarDimensionSide = function SvgCarDimensionSide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 119h129v1H1v-1Z",
    fill: "#282830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.236 6.946S101.272 1 94.136 1H35.861c-7.136 0-11.1 5.946-11.1 5.946L6.525 50.157V78.7h116.55V50.157l-17.839-43.21Z",
    fill: "#fff",
    stroke: "#697173"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 39.85h110.208M97.701 68.787c5.55 0 9.911-4.36 9.911-9.514 0-5.55-4.361-9.514-9.91-9.514-5.55 0-9.515 4.36-9.515 9.514-.396 5.154 3.965 9.514 9.514 9.514Zm-65.014 0c5.55 0 9.515-4.36 9.515-9.514 0-5.55-4.361-9.514-9.515-9.514-5.153 0-9.514 4.36-9.514 9.514 0 5.154 4.36 9.514 9.514 9.514Z",
    stroke: "#697173"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.472 39.85c3.568 0 6.343-2.775 6.343-6.343 0-3.567-2.775-6.342-6.343-6.342s-6.343 2.775-6.343 6.342c0 3.568 2.775 6.343 6.343 6.343Zm-116.55 0c3.568 0 6.343-2.775 6.343-6.343 0-3.567-2.775-6.342-6.343-6.342S.579 29.94.579 33.507c0 3.568 2.775 6.343 6.343 6.343Z",
    fill: "#697173"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.69 90.197c0 7.135-5.947 13.082-13.082 13.082A13.084 13.084 0 0 1 6.525 90.197V78.7h25.768v11.497h.397Zm90.782 0c0 7.135-5.947 13.082-13.082 13.082a13.086 13.086 0 0 1-13.082-13.082V78.7h25.767v11.497h.397Z",
    fill: "#fff",
    stroke: "#697173"
  })));
};
export default SvgCarDimensionSide;